import React from 'react';
import { useTheme } from '../../theme/ThemeProvider';

export default function SecurityShell({ title, subtitle, badge = 'NEO SECURITY', children, aside, topAction = null }) {
  const { themeMode } = useTheme();
  const tone = themeMode === 'light' ? lightStyles : darkStyles;

  return (
    <div style={{ ...styles.page, ...tone.page }}>
      <div style={styles.wrap}>
        <div style={{ ...styles.hero, ...tone.hero }}>
          <div style={styles.heroTop}>
            <div>
              <div style={{ ...styles.badge, ...tone.badge }}>{badge}</div>
              <h1 style={{ ...styles.title, ...tone.title }}>{title}</h1>
              {subtitle ? <p style={{ ...styles.subtitle, ...tone.subtitle }}>{subtitle}</p> : null}
            </div>
            {topAction ? <div style={styles.topActionWrap}>{topAction}</div> : null}
          </div>
        </div>

        <div style={{ ...styles.contentGrid, ...tone.contentGrid }}>
          <div>{children}</div>
          {aside ? <div>{aside}</div> : null}
        </div>
      </div>
    </div>
  );
}

export const cardStyle = {
  borderRadius: 24,
  padding: 18,
};

export const pillStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 12px',
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 800,
};

const styles = {
  page: {
    minHeight: '100vh',
    background:
      'radial-gradient(circle at top, rgba(14,165,233,.16), transparent 28%), linear-gradient(180deg, #020617 0%, #0f172a 100%)',
    color: '#e2e8f0',
    padding: '18px 16px 40px',
  },
  wrap: {
    maxWidth: 1180,
    margin: '0 auto',
  },
  hero: {
    ...cardStyle,
    padding: 24,
    background: 'linear-gradient(180deg, rgba(8,47,73,.38), rgba(15,23,42,.92))',
  },
  heroTop: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  topActionWrap: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  badge: {
    display: 'inline-flex',
    padding: '7px 12px',
    borderRadius: 999,
    fontWeight: 900,
    fontSize: 12,
    letterSpacing: '.08em',
    color: '#bae6fd',
    background: 'rgba(14,165,233,.16)',
  },
  title: { margin: '14px 0 8px', fontSize: 30, lineHeight: 1.1 },
  subtitle: { margin: 0, lineHeight: 1.7, opacity: 0.9, maxWidth: 840 },
  contentGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.7fr) minmax(280px, .9fr)',
    gap: 16,
    marginTop: 16,
  },
};


const darkStyles = {
  page: {
    background:
      'radial-gradient(circle at top, rgba(14,165,233,.16), transparent 28%), linear-gradient(180deg, #020617 0%, #0f172a 100%)',
    color: '#e2e8f0',
  },
  hero: {
    border: '1px solid rgba(255,255,255,.08)',
    background: 'linear-gradient(180deg, rgba(8,47,73,.38), rgba(15,23,42,.92))',
    boxShadow: '0 18px 44px rgba(0,0,0,.22)',
  },
  badge: {
    color: '#bae6fd',
    background: 'rgba(14,165,233,.16)',
  },
  title: { color: '#f8fbff' },
  subtitle: { color: 'rgba(226,232,240,.92)' },
  contentGrid: {},
};

const lightStyles = {
  page: {
    background:
      'radial-gradient(circle at top, rgba(47,128,237,.10), transparent 24%), linear-gradient(180deg, #eef3f8 0%, #e9eff6 100%)',
    color: '#12335f',
  },
  hero: {
    border: '1px solid rgba(15,23,42,.08)',
    background: 'linear-gradient(180deg, rgba(255,255,255,.96), rgba(244,247,251,.96))',
    boxShadow: '0 20px 40px rgba(15,23,42,.06)',
  },
  badge: {
    color: '#2f6ff2',
    background: 'rgba(47,128,237,.10)',
  },
  title: { color: '#12335f' },
  subtitle: { color: '#607897' },
  contentGrid: {},
};
